"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Drawer;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Handle = _interopRequireWildcard(require("../Handle"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var handleDelta = 17;
var keyStep = 10;

var Aside = _styledComponents["default"].aside.withConfig({
  displayName: "Drawer__Aside",
  componentId: "sc-16m4luv-0"
})(function (props) {
  return (0, _styledComponents.css)(["margin:0;display:flex;z-index:", ";cursor:default;user-select:none;background-color:", ";box-shadow:", " 0 ", " ", ";", " ", " ", ""], props.theme.layer.panels, props.theme.color.paper, props.theme.globalSizes.small, props.theme.globalSizes.xl, props.theme.color.structure, !props.isDragging && (0, _styledComponents.css)(["transition:width 250ms ease;"]), props.isAnchoredLeft ? (0, _styledComponents.css)(["left:0;"]) : (0, _styledComponents.css)(["flex-direction:row-reverse;right:0;"]), props.fixed ? (0, _styledComponents.css)(["position:fixed;height:100vh;top:0;"]) : (0, _styledComponents.css)(["position:absolute;height:100%;"]));
});

var ContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "Drawer__ContentContainer",
  componentId: "sc-16m4luv-1"
})(function (_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(["position:relative;flex-grow:1;height:100%;overflow-x:hidden;scrollbar-width:thin;scrollbar-color:", " ", ";::-webkit-scrollbar{position:absolute;width:8px;float:right;}::-webkit-scrollbar-thumb{border-radius:8px;background-color:", ";}"], theme.color.action, theme.color.paper, theme.color.action);
});

function getNewWidth(key, width, isAnchoredLeft) {
  switch (key) {
    case 'ArrowRight':
    case 'ArrowUp':
      return isAnchoredLeft ? width + keyStep : width - keyStep;

    case 'ArrowLeft':
    case 'ArrowDown':
      return isAnchoredLeft ? width - keyStep : width + keyStep;

    default:
      return width;
  }
}
/**
 *
 * ### Content panel component

This component is a dockable panel that slides in from either side of the current view. Generally it is to be used as a container for accompanying content for the main page. It can be static or draggable depending on the behaviour required.
 */


function Drawer(_ref2) {
  var children = _ref2.children,
      _ref2$anchor = _ref2.anchor,
      anchor = _ref2$anchor === void 0 ? 'left' : _ref2$anchor,
      _ref2$fixed = _ref2.fixed,
      fixed = _ref2$fixed === void 0 ? false : _ref2$fixed,
      _ref2$docked = _ref2.docked,
      docked = _ref2$docked === void 0 ? false : _ref2$docked,
      _ref2$draggable = _ref2.draggable,
      draggable = _ref2$draggable === void 0 ? false : _ref2$draggable,
      _ref2$snapThreshold = _ref2.snapThreshold,
      snapThreshold = _ref2$snapThreshold === void 0 ? 50 : _ref2$snapThreshold,
      _ref2$initialWidth = _ref2.initialWidth,
      initialWidth = _ref2$initialWidth === void 0 ? 300 : _ref2$initialWidth,
      maxWidth = _ref2.maxWidth,
      containerRef = _ref2.containerRef,
      _ref2$onWidthChange = _ref2.onWidthChange,
      onWidthChange = _ref2$onWidthChange === void 0 ? function () {} : _ref2$onWidthChange,
      _ref2$onDocked = _ref2.onDocked,
      onDocked = _ref2$onDocked === void 0 ? function () {} : _ref2$onDocked,
      _ref2$onUnDocked = _ref2.onUnDocked,
      onUnDocked = _ref2$onUnDocked === void 0 ? function () {} : _ref2$onUnDocked;

  var _React$useState = _react["default"].useState(initialWidth),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      width = _React$useState2[0],
      setWidth = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isDragging = _React$useState4[0],
      setIsDragging = _React$useState4[1];

  var previousWidth = _react["default"].useRef(initialWidth);

  var isDocked = _react["default"].useRef(docked);

  var drawerRef = _react["default"].useRef();

  var setWidthStyle = function setWidthStyle() {
    return {
      width: "".concat(docked ? 0 : width, "px")
    };
  };

  var isAnchoredLeft = anchor.toLowerCase() === 'left';

  _react["default"].useEffect(function () {
    if (docked) {
      if (width > 0) {
        previousWidth.current = width;
      }

      isDocked.current = true;
      setWidth(0);
      onDocked(0);
    } else if (!isDragging) {
      isDocked.current = false;
      setWidth(previousWidth.current);
      onUnDocked(previousWidth.current);
    }
  }, [docked]);

  _react["default"].useEffect(function () {
    var _containerRef$current;

    var containerWidth = (_containerRef$current = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.getBoundingClientRect().width) !== null && _containerRef$current !== void 0 ? _containerRef$current : window.innerWidth;

    if (width > containerWidth) {
      setWidth(containerWidth);
    }
  }, [fixed]);

  function removeMouseEventListeners() {
    window.removeEventListener('mousemove', handleDrag);
    window.removeEventListener('mouseup', handleDragEnd);
  }

  function addMouseEventListeners() {
    window.addEventListener('mousemove', handleDrag);
    window.addEventListener('mouseup', handleDragEnd);
  }

  function handleKeyDown(event) {
    var _containerRef$current2, _containerRef$current3;

    var containerWidth = fixed ? window.innerWidth : (_containerRef$current2 = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.getBoundingClientRect().width) !== null && _containerRef$current2 !== void 0 ? _containerRef$current2 : window.innerWidth;
    var containerLeft = fixed ? 0 : (_containerRef$current3 = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.getBoundingClientRect().left) !== null && _containerRef$current3 !== void 0 ? _containerRef$current3 : 0;
    var newWidth = getNewWidth(event.key, width, isAnchoredLeft);
    var clientX = isAnchoredLeft ? newWidth + containerLeft - handleDelta : containerWidth - newWidth + containerLeft + handleDelta;
    handleDrag({
      clientX: clientX
    });
    onWidthChange(newWidth);
  }

  function handleDrag(_ref3) {
    var _containerRef$current4, _containerRef$current5;

    var clientX = _ref3.clientX;
    var containerWidth = fixed ? window.innerWidth : (_containerRef$current4 = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.getBoundingClientRect().width) !== null && _containerRef$current4 !== void 0 ? _containerRef$current4 : window.innerWidth;
    var containerLeft = fixed ? 0 : (_containerRef$current5 = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.getBoundingClientRect().left) !== null && _containerRef$current5 !== void 0 ? _containerRef$current5 : 0;
    var drawerAnchor = isAnchoredLeft ? 0 : containerWidth;
    var mouseX = isAnchoredLeft ? clientX + handleDelta : -clientX + handleDelta;
    var containerX = isAnchoredLeft ? -containerLeft : containerLeft;
    var drawerMaxWidth = Math.min(containerWidth, maxWidth || window.innerWidth);

    if (isDocked.current) {
      if (isAnchoredLeft && clientX >= containerLeft + snapThreshold || !isAnchoredLeft && clientX <= containerWidth - snapThreshold + containerLeft) {
        if (isDocked.current) {
          isDocked.current = false;
          onUnDocked(width);
        }
      }
    }

    if (isAnchoredLeft && clientX < containerLeft + snapThreshold || !isAnchoredLeft && clientX > containerWidth - snapThreshold + containerLeft) {
      if (!isDocked.current) {
        isDocked.current = true;
        onDocked(width);
      }

      setWidth(0);
      return;
    }

    setWidth(Math.max(0, Math.min(drawerMaxWidth, drawerAnchor + containerX + mouseX)));
  }

  function handleDragStart(_ref4) {
    var clientX = _ref4.clientX;

    if (!isDragging) {
      removeMouseEventListeners();
      setIsDragging(true);
      addMouseEventListeners();
      return;
    }

    setWidth(handleDrag({
      clientX: clientX
    }));
  }

  function handleDragEnd() {
    var currentWidth = drawerRef.current.getBoundingClientRect().width;
    setIsDragging(false);

    if (currentWidth > 0) {
      previousWidth.current = currentWidth;
    }

    removeMouseEventListeners();
    onWidthChange(currentWidth);
  }

  return /*#__PURE__*/_react["default"].createElement(Aside, {
    isAnchoredLeft: isAnchoredLeft,
    isDragging: isDragging,
    fixed: fixed,
    style: setWidthStyle(),
    ref: drawerRef
  }, /*#__PURE__*/_react["default"].createElement(ContentContainer, {
    "aria-expanded": !docked
  }, children), draggable && /*#__PURE__*/_react["default"].createElement(_Handle["default"], {
    direction: isAnchoredLeft ? _Handle.handleDirection.RIGHT : _Handle.handleDirection.LEFT,
    cursor: "col-resize",
    onMouseDown: handleDragStart,
    onKeyDown: handleKeyDown,
    onKeyUp: handleDragEnd
  }));
}